export const SMART_FOLDER_AUTO_SYNC_FRESHNESS_MS: number = 15 * 60 * 1000;

const lastAutoSyncAtByFolderId = new Map<string, number>();

const isFreshTimestamp = (timestampMs: number, now: number): boolean => {
	const ageMs = now - timestampMs;
	return ageMs >= 0 && ageMs < SMART_FOLDER_AUTO_SYNC_FRESHNESS_MS;
};

const pruneStaleRememberedSyncs = (now: number): void => {
	for (const [folderId, rememberedAt] of lastAutoSyncAtByFolderId) {
		if (!isFreshTimestamp(rememberedAt, now)) {
			lastAutoSyncAtByFolderId.delete(folderId);
		}
	}
};

export const rememberSmartFolderAutoSync = (folderId: string, at: number = Date.now()): void => {
	pruneStaleRememberedSyncs(at);
	lastAutoSyncAtByFolderId.set(folderId, at);
};

/** Test-only reset for the in-tab last-sync memory. */
export const clearSmartFolderAutoSyncMemory = (): void => {
	lastAutoSyncAtByFolderId.clear();
};

export const shouldSkipSmartFolderAutoSync = ({
	folderId,
	lastSynced,
	now = Date.now(),
}: {
	folderId: string;
	lastSynced?: string | null;
	now?: number;
}): boolean => {
	const rememberedAt = lastAutoSyncAtByFolderId.get(folderId);
	if (rememberedAt !== undefined && isFreshTimestamp(rememberedAt, now)) {
		return true;
	}

	if (!lastSynced) {
		return false;
	}

	const lastSyncedMs = Date.parse(lastSynced);
	if (Number.isNaN(lastSyncedMs)) {
		return false;
	}

	return isFreshTimestamp(lastSyncedMs, now);
};
